(ns frontend.ui.component.lp-portal.news-section.style
  (:require
   [garden.util :refer [space-join]]
   [frontend.ui.style.theme.core :refer [color]]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [text-size color]]))

(defn section-container
  []
  (with-meta
    {:display        :flex
     :flex-direction :column
     :padding        "50px 16px"
     :gap            :40px}
    {:media
     [{:screen :only :max-width :599px}
      {:padding "16px"
       :gap     :16px}]}))

(defn section-menu
  []
  {:display         :flex
   :padding         "0 16px"
   :justify-content :space-between
   :position        :relative})

(defn content-container
  []
  ^{:media
    {{:screen :only :max-width :912px}
     {:flex-direction :column-reverse}
     {:screen :only :max-width :599px}
     {:gap :16px}}}
  {:display :flex
   :gap     :40px})

(defn news-container
  []
  (with-meta
    {:display :grid
     :gap     "70px 40px" 
     :grid-template-columns "repeat(auto-fill, minmax(220px, 1fr))"
     :flex    :1}
    {:media
     {{:screen :only :max-width :912px}
      {:gap :40px}
      {:screen :only :max-width :599px}
      {:gap :16px}}}))

(defn no-results
  []
  {:flex           :1
   :display        :flex
   :flex-direction :column
   :justify-content :center
   :align-items    :center
   :gap            :8px})

(defn reset-filters
  []
  {:user-select    :none
   :text-transform :uppercase
   :align-items    :center
   :text-align     :right
   :white-space    :nowrap
   :cursor         :pointer
   :font-weight    :700
   :font-size      :12px
   :letter-spacing :2.2px
   :display        :flex
   :border-radius  "25px"
   :background     (theme/color [:button :regular :light :bg])
   :padding        "12px 32px"
   :color          (theme/color [:text :primary :color])})

(defn sidebar-container
  []
  ^{:media
    {{:screen :only :max-width :912px}
     {:width   :initial
      :padding "24px 16px"}
     {:screen :only :max-width :599px}
     {:gap     :30px
      :padding "30px 24px"
      :display :none}}}
  {:width           :280px
   :display         :flex
   :flex-direction  :column
   :justify-content :space-between
   :border-radius   :16px
   :background      (theme/color [:news-section :general :bg])
   :padding         "40px 30px"
   :color           (theme/color [:news-section :general :color])
   :gap             :40px})

(defn sidebar-top-container
  []
  {:display :flex
   :flex-direction :column
   :gap     :20px})

(defn sidebar-title
  []
  ^{:media
    {{:screen :only :max-width :912px}
     {:padding "0 0 16px"}
     {:screen :only :max-width :599px}
     {:display :none}}}
  {:padding-bottom :72px
   :font-size      (text-size :large :size)})

(defn dropdown-container
  []
  {:display  :flex
   :flex     :1
   :position :relative})

(defn dropdown
  []
  (with-meta
    {:background     (theme/color [:news-section :dropdown :background])
     :border         (space-join ["1px" "solid" (theme/color [:news-section :dropdown :border])])
     :appearance     :none
     :flex           :1
     :width          "100%"
     :padding        "18px 14px"
     :text-transform :uppercase
     :font-size      (text-size :xxsmall :size)
     :font-weight    :700
     :letter-spacing :0.2em
     :color          (theme/color [:news-section :dropdown :color])}
    {:pseudo
     {:focus {:outline (space-join ["4px" "solid"
                                    (theme/color [:news-section :dropdown :outline])])}}
     :combinators {[:> :option]
                   {:color (theme/color [:news-section :dropdown-option :color])}
                  }}))

(defn dropdown-caret
  []
  {:width          :10px
   :position       :absolute
   :right          :14px
   :top            :50%
   :margin-top     :-8px
   :pointer-events :none})

(defn show-all-link
  []
  (with-meta
    {:display     :flex
     :justify-content :flex-end
     :align-items :flex-end
     :gap         :8px
     :text-decoration :none
     :color       (theme/color [:news-section :show-all :default :color])}
    {:pseudo
     {:hover
      {:color (theme/color [:news-section :show-all :hover :color])}}}))

(defn angle-double-right
  []
  {:margin-bottom :-2px})
